export const actionTypePrefix = '@@EmoteSelector';
export const reduxKey = '@@EmoteSelector';
